export default "__VITE_ASSET__BFj25OOB__"